var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEquipmentToolsAccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    rx: 6,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3133 42.3383H51.9845L51.9841 18.9596C51.9841 17.328 50.6565 16 49.0245 16H15.8495C14.2179 16 12.8899 17.3276 12.8899 18.9596V42.3383H10.5611C10.2508 42.3383 10 42.5891 10 42.8994V44.1324C10 45.7135 11.2861 47 12.8677 47H52.0065C53.5876 47 54.8741 45.7139 54.8741 44.1324V42.8994C54.8741 42.5891 54.6232 42.3383 54.3133 42.3383ZM14.0116 18.9596C14.0116 17.9458 14.836 17.1222 15.849 17.1222H49.024C50.0378 17.1222 50.8614 17.9466 50.8614 18.9596V42.3383H49.1781L49.1785 19.9082C49.1785 19.5979 48.9277 19.3471 48.6174 19.3471H16.2558C15.9456 19.3471 15.6948 19.5979 15.6948 19.9082V42.3383H14.0115L14.0116 18.9596ZM48.057 42.3383H16.8162V20.4691H48.056V42.3383H48.057ZM53.7519 44.1319C53.7519 45.0944 52.969 45.8774 52.0064 45.8774L12.8666 45.8778C11.9041 45.8778 11.1211 45.0948 11.1211 44.1323V43.4605H53.7517L53.7519 44.1319Z",
    fill: "#212121",
    stroke: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7179 45.194H36.1561C36.4664 45.194 36.7172 44.9431 36.7172 44.6329C36.7172 44.3226 36.4664 44.0718 36.1561 44.0718H28.7179C28.4077 44.0718 28.1569 44.3226 28.1569 44.6329C28.1573 44.9431 28.4081 45.194 28.7179 45.194Z",
    fill: "#212121",
    stroke: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentToolsAccessIcon);
export default __webpack_public_path__ + "static/media/equipment-tools-access-icon.a5ea9e586c331c3e2af0f23bd1e88af1.svg";
export { ForwardRef as ReactComponent };